/* Alaska TechStore — scripts do tema */
(function () {
  'use strict';

  var A = window.alaska || {};

  /* ---------- utilidades ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    format = format || A.moneyFormat || '${{amount}}';
    cents = Number(cents) || 0;
    function withDelims(n, decimals, thousands, decimal) {
      var parts = (n / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[0] + (parts[1] ? decimal + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(cents, 2, "'", '.');
        default: return withDelims(cents, 2, ',', '.');
      }
    });
  }

  function waUrl(message) {
    var n = A.whatsapp || '';
    return 'https://wa.me/' + n + (message ? '?text=' + encodeURIComponent(message) : '');
  }

  /* ---------- biblioteca 3D (carrega só quando precisa) ---------- */
  var threePromise = null;
  function loadThree() {
    if (window.THREE && window.THREE.GLTFLoader) return Promise.resolve(window.THREE);
    if (threePromise) return threePromise;
    threePromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = A.threeUrl;
      s.async = true;
      s.onload = function () { window.THREE && window.THREE.GLTFLoader ? resolve(window.THREE) : reject(new Error('three')); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return threePromise;
  }

  /* ---------- visualizador 3D do iPhone ---------- */
  function webglAvailable() {
    try {
      var c = document.createElement('canvas');
      return !!(window.WebGLRenderingContext && (c.getContext('webgl') || c.getContext('experimental-webgl')));
    } catch (e) { return false; }
  }

  function PhoneViewer(root) {
    this.root = root;
    this.scope = root.closest('[data-viewer-scope]') || root.parentNode;
    this.canvas = $('canvas', root);
    this.status = $('[data-viewer-status]', root);
    this.fallback = $('[data-viewer-fallback]', root);
    try { this.models = JSON.parse(root.getAttribute('data-models') || '[]'); } catch (e) { this.models = []; }
    this.current = 0;
    this.view = 'spin';
    this.api = null;
    this.bindControls();
    if (!this.models.length || !webglAvailable()) { this.showFallback(); return; }
    var self = this;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); self.start(); }
      }, { rootMargin: '200px' });
      io.observe(root);
    } else {
      this.start();
    }
  }

  PhoneViewer.prototype.setStatus = function (text) {
    if (!this.status) return;
    this.status.textContent = text || '';
    this.status.hidden = !text;
  };

  PhoneViewer.prototype.showFallback = function () {
    this.setStatus('');
    if (this.fallback) this.fallback.hidden = false;
    if (this.canvas) this.canvas.hidden = true;
    $$('[data-viewer-bar]', this.scope).forEach(function (b) { b.hidden = true; });
  };

  PhoneViewer.prototype.bindControls = function () {
    var self = this;
    $$('[data-viewer-swatch]', this.scope).forEach(function (btn) {
      btn.addEventListener('click', function () { self.setColor(Number(btn.getAttribute('data-viewer-swatch'))); });
    });
    $$('[data-viewer-view]', this.scope).forEach(function (btn) {
      btn.addEventListener('click', function () { self.setView(btn.getAttribute('data-viewer-view')); });
    });
  };

  PhoneViewer.prototype.setColor = function (i) {
    if (i < 0 || i >= this.models.length) return;
    this.current = i;
    $$('[data-viewer-swatch]', this.scope).forEach(function (b) {
      b.setAttribute('aria-pressed', Number(b.getAttribute('data-viewer-swatch')) === i ? 'true' : 'false');
    });
    var label = $('[data-viewer-color-name]', this.scope);
    if (label) label.textContent = this.models[i].name;
    if (this.canvas) this.canvas.setAttribute('aria-label', '3D do aparelho na cor ' + this.models[i].name + '. Arraste para girar.');
    if (this.api) this.api.setColor(i);
  };

  PhoneViewer.prototype.setColorByName = function (name) {
    if (!name) return;
    var n = String(name).toLowerCase();
    for (var i = 0; i < this.models.length; i++) {
      var m = String(this.models[i].name || '').toLowerCase();
      if (m && (m === n || m.indexOf(n) >= 0 || n.indexOf(m) >= 0)) { this.setColor(i); return; }
    }
  };

  PhoneViewer.prototype.setView = function (k) {
    this.view = k;
    $$('[data-viewer-view]', this.scope).forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-viewer-view') === k ? 'true' : 'false');
    });
    if (this.api) this.api.setView(k);
  };

  PhoneViewer.prototype.start = function () {
    var self = this;
    this.setStatus('Carregando o 3D…');
    loadThree().then(function (T) { self.init(T); }).catch(function () { self.showFallback(); });
  };

  PhoneViewer.prototype.init = function (T) {
    var self = this, cv = this.canvas;
    var renderer;
    try { renderer = new T.WebGLRenderer({ canvas: cv, antialias: true, alpha: true }); }
    catch (e) { this.showFallback(); return; }
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.outputEncoding = T.sRGBEncoding;
    renderer.toneMapping = T.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.0;
    renderer.physicallyCorrectLights = true;

    var scene = new T.Scene();
    var camera = new T.PerspectiveCamera(20, 1, 0.5, 400);
    camera.position.set(0, 1.5, 64);
    camera.lookAt(0, 0, 0);

    var pm = new T.PMREMGenerator(renderer);
    scene.environment = pm.fromScene(new T.RoomEnvironment(), 0.03).texture;
    var key = new T.DirectionalLight(0xffffff, 1.6); key.position.set(-10, 16, 22); scene.add(key);
    var rim = new T.DirectionalLight(0xffffff, 1.0); rim.position.set(14, 6, -18); scene.add(rim);

    var H = 16.3;
    var rig = new T.Group();
    scene.add(rig);

    var shc = document.createElement('canvas'); shc.width = 256; shc.height = 256;
    var sg = shc.getContext('2d');
    var rgd = sg.createRadialGradient(128, 128, 0, 128, 128, 128);
    rgd.addColorStop(0, 'rgba(0,0,0,0.5)'); rgd.addColorStop(0.5, 'rgba(0,0,0,0.16)'); rgd.addColorStop(1, 'rgba(0,0,0,0)');
    sg.fillStyle = rgd; sg.fillRect(0, 0, 256, 256);
    var shadow = new T.Mesh(new T.PlaneGeometry(13, 3.6), new T.MeshBasicMaterial({ map: new T.CanvasTexture(shc), transparent: true, depthWrite: false }));
    shadow.rotation.x = -Math.PI / 2;
    shadow.position.y = -H / 2 - 1.1;
    scene.add(shadow);

    var loader = new T.GLTFLoader();
    loader.setCrossOrigin('anonymous');
    var holders = {}, loading = {}, want = this.current, alive = true;

    function prepare(model) {
      var box = new T.Box3().setFromObject(model);
      var size = box.getSize(new T.Vector3());
      if (size.z > size.y && size.z >= size.x) model.rotation.x = -Math.PI / 2;
      else if (size.x > size.y && size.x >= size.z) model.rotation.z = Math.PI / 2;
      model.updateMatrixWorld(true);
      box = new T.Box3().setFromObject(model);
      var center = box.getCenter(new T.Vector3());
      var screen = null;
      model.traverse(function (o) { if (!screen && o.isMesh && /Screen/i.test((o.material && o.material.name) || '')) screen = o; });
      if (screen) {
        var sc = new T.Box3().setFromObject(screen).getCenter(new T.Vector3()).sub(center);
        model.rotation.y = -Math.atan2(sc.x, sc.z);
        model.updateMatrixWorld(true);
      }
      var holder = new T.Group();
      holder.add(model);
      box = new T.Box3().setFromObject(holder);
      size = box.getSize(new T.Vector3());
      var s = H / size.y;
      holder.scale.setScalar(s);
      holder.position.sub(box.getCenter(new T.Vector3()).multiplyScalar(s));
      model.traverse(function (o) {
        if (!o.isMesh) return;
        (Array.isArray(o.material) ? o.material : [o.material]).forEach(function (m) {
          if (!m) return; m.envMapIntensity = 1.1; if (m.map) m.map.anisotropy = 8;
        });
      });
      return holder;
    }
    function show() {
      Object.keys(holders).forEach(function (k) { holders[k].visible = Number(k) === want; });
      if (holders[want]) self.setStatus('');
    }
    function load(i) {
      if (holders[i] || loading[i]) { show(); return; }
      loading[i] = true;
      if (i === want) self.setStatus('Carregando o 3D…');
      loader.load(self.models[i].url, function (gltf) {
        if (!alive) return;
        holders[i] = prepare(gltf.scene);
        rig.add(holders[i]);
        show();
      }, undefined, function () {
        loading[i] = false;
        if (alive && i === want) self.showFallback();
      });
    }
    load(want);

    var target = -0.45, cur = -0.45, auto = this.view === 'spin', dragging = false, lastX = 0, idleAt = 0;
    cv.addEventListener('pointerdown', function (e) { dragging = true; lastX = e.clientX; cv.style.cursor = 'grabbing'; try { cv.setPointerCapture(e.pointerId); } catch (x) {} });
    cv.addEventListener('pointermove', function (e) { if (!dragging) return; target += (e.clientX - lastX) * 0.012; lastX = e.clientX; idleAt = performance.now(); });
    function up() { if (!dragging) return; dragging = false; cv.style.cursor = 'grab'; idleAt = performance.now(); }
    cv.addEventListener('pointerup', up);
    cv.addEventListener('pointercancel', up);

    function fit() {
      var r = cv.getBoundingClientRect();
      var w = Math.max(1, r.width), h = Math.max(1, r.height);
      renderer.setSize(w, h, false);
      camera.aspect = w / h;
      var t = Math.tan(T.MathUtils.degToRad(10));
      camera.position.z = Math.max(21.5 / (2 * t), 12 / (2 * t * camera.aspect));
      camera.updateProjectionMatrix();
    }
    fit();
    if (window.ResizeObserver) new ResizeObserver(fit).observe(cv);

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var visible = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(cv);
    }
    function loop(t) {
      requestAnimationFrame(loop);
      if (!visible || document.hidden) return;
      if (auto && !dragging && !reduce && t - idleAt > 2500) target += 0.0032;
      cur += (target - cur) * 0.07;
      rig.rotation.set(-0.05, cur, 0.015);
      rig.position.y = reduce ? 0 : Math.sin(t * 0.0011) * 0.12;
      renderer.render(scene, camera);
    }
    requestAnimationFrame(loop);

    this.api = {
      setView: function (k) {
        auto = k === 'spin';
        if (k === 'spin') return;
        var turn = Math.PI * 2, base = Math.round(cur / turn) * turn;
        target = base + (k === 'front' ? -0.45 : Math.PI + 0.45);
      },
      setColor: function (i) { want = i; load(i); show(); }
    };
    window.addEventListener('pagehide', function () { alive = false; });
  };

  function initViewers(root) {
    $$('[data-phone-viewer]', root).forEach(function (el) {
      if (el.__viewer) return;
      el.__viewer = new PhoneViewer(el);
    });
  }

  /* ---------- abas de produtos ---------- */
  function initTabs(root) {
    $$('[data-tabs]', root).forEach(function (wrap) {
      if (wrap.__tabs) return;
      wrap.__tabs = true;
      var buttons = $$('[role="tab"]', wrap);
      function select(btn, focus) {
        buttons.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) btn.focus();
      }
      buttons.forEach(function (b, i) {
        b.addEventListener('click', function () { select(b); });
        b.addEventListener('keydown', function (e) {
          var j = null;
          if (e.key === 'ArrowRight') j = (i + 1) % buttons.length;
          if (e.key === 'ArrowLeft') j = (i - 1 + buttons.length) % buttons.length;
          if (e.key === 'Home') j = 0;
          if (e.key === 'End') j = buttons.length - 1;
          if (j !== null) { e.preventDefault(); select(buttons[j], true); }
        });
      });
    });
  }

  /* ---------- horário: aberto / fechado ---------- */
  function initHours(root) {
    $$('[data-store-hours]', root).forEach(function (el) {
      var cfg;
      try { cfg = JSON.parse(el.getAttribute('data-store-hours')); } catch (e) { return; }
      var wd = 1, hr = 12;
      try {
        var parts = new Intl.DateTimeFormat('en-US', { timeZone: cfg.tz || 'America/New_York', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date());
        var g = function (t) { var p = parts.filter(function (x) { return x.type === t; })[0]; return p ? p.value : ''; };
        wd = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(g('weekday'));
        hr = (Number(g('hour')) % 24) + Number(g('minute')) / 60;
      } catch (e) { /* mantém padrão */ }
      // cfg.days[0..6] = [abre, fecha] ou null (fechado), domingo = 0
      var today = cfg.days[wd];
      var open = !!today && hr >= today[0] && hr < today[1];
      var fmt = function (h) { var hh = Math.floor(h), mm = Math.round((h - hh) * 60); return hh + 'h' + (mm ? String(mm).padStart(2, '0') : ''); };
      var names = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];
      var text;
      if (open) {
        text = 'Aberto agora · fecha às ' + fmt(today[1]);
      } else if (today && hr < today[0]) {
        text = 'Fechado · abre hoje às ' + fmt(today[0]);
      } else {
        text = 'Fechado';
        for (var k = 1; k <= 7; k++) {
          var d = (wd + k) % 7;
          if (cfg.days[d]) { text = 'Fechado · abre ' + (k === 1 ? 'amanhã' : names[d]) + ' às ' + fmt(cfg.days[d][0]); break; }
        }
      }
      var pill = $('[data-open-pill]', el);
      if (pill) { pill.textContent = text; pill.classList.toggle('is-open', open); pill.hidden = false; }
      $$('[data-hours-row]', el).forEach(function (row) {
        var ds = row.getAttribute('data-hours-row').split(',').map(Number);
        row.classList.toggle('is-today', ds.indexOf(wd) >= 0);
      });
    });
  }

  /* ---------- câmbio ---------- */
  function initExchange(root) {
    $$('[data-exchange]', root).forEach(function (el) {
      if (el.__fx) return;
      el.__fx = true;
      var input = $('[data-fx-input]', el);
      var out = $('[data-fx-output]', el);
      var note = $('[data-fx-note]', el);
      var adjust = Number(el.getAttribute('data-fx-adjust')) || 0;
      var rate = Number(el.getAttribute('data-fx-fallback')) || 0;
      var source = 'referência';
      function render() {
        var usd = Number(String(input.value).replace(',', '.')) || 0;
        var eff = rate * (1 + adjust / 100);
        out.textContent = 'R$ ' + (usd * eff).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        if (note) note.textContent = 'Cotação ' + source + ': US$ 1 = R$ ' + eff.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '. O valor final é confirmado no balcão.';
      }
      input.addEventListener('input', render);
      render();
      if (el.getAttribute('data-fx-live') === 'true' && window.fetch) {
        fetch('https://economia.awesomeapi.com.br/json/last/USD-BRL')
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var b = j && j.USDBRL && Number(j.USDBRL.bid);
            if (b) {
              rate = b;
              var d = new Date(Number(j.USDBRL.timestamp) * 1000);
              source = 'comercial de ' + d.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
              render();
            }
          })
          .catch(function () { /* fica com a cotação de referência */ });
      }
    });
  }

  /* ---------- trade-in: enviar pelo WhatsApp ---------- */
  function initTradeIn(root) {
    $$('[data-tradein-wa]', root).forEach(function (btn) {
      if (btn.__wa) return;
      btn.__wa = true;
      btn.addEventListener('click', function () {
        var form = btn.closest('form');
        var get = function (n) { var f = form.querySelector('[name="' + n + '"]'); return f ? f.value.trim() : ''; };
        var msg = 'Olá! Quero avaliar meu aparelho para trade-in.\n' +
          'Modelo: ' + get('contact[Modelo]') + '\n' +
          'Estado: ' + get('contact[Estado]') +
          (get('contact[name]') ? '\nNome: ' + get('contact[name]') : '');
        window.open(waUrl(msg), '_blank', 'noopener');
      });
    });
  }

  /* ---------- página de produto ---------- */
  function initProduct(root) {
    $$('[data-product-form-root]', root).forEach(function (wrap) {
      if (wrap.__pf) return;
      wrap.__pf = true;
      var data;
      try { data = JSON.parse($('[data-product-json]', wrap).textContent); } catch (e) { return; }
      var idInput = $('[data-variant-id]', wrap);
      var priceEl = $('[data-price]', wrap);
      var compareEl = $('[data-compare]', wrap);
      var addBtn = $('[data-add]', wrap);
      var waBtn = $('[data-wa-product]', wrap);
      var waTpl = waBtn ? waBtn.getAttribute('data-template') : '';
      var boMap = {};
      try { boMap = JSON.parse($('[data-backorder-json]', wrap).textContent); } catch (e) { boMap = {}; }
      var boNote = $('[data-backorder-note]', wrap);
      var fieldsets = $$('[data-option-index]', wrap);
      var scope = wrap.closest('[data-product-section]') || document;
      var viewerEl = $('[data-phone-viewer]', scope);
      var mainImg = $('[data-main-image]', scope);

      function selected() {
        return fieldsets.map(function (fs) {
          var c = $('input:checked', fs);
          return c ? c.value : null;
        });
      }
      function findVariant(opts) {
        return data.variants.filter(function (v) {
          return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
        })[0];
      }
      function markAvailability(opts) {
        fieldsets.forEach(function (fs, idx) {
          $$('input', fs).forEach(function (inp) {
            var test = opts.slice(); test[idx] = inp.value;
            var ok = data.variants.some(function (v) {
              return v.available && v.options.every(function (o, i) { return test[i] === null || o === test[i]; });
            });
            inp.classList.toggle('is-unavailable', !ok);
          });
          var label = $('[data-option-value]', fs);
          var c = $('input:checked', fs);
          if (label && c) label.textContent = c.value;
        });
      }
      function update() {
        var opts = selected();
        var v = findVariant(opts);
        markAvailability(opts);
        if (!v) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Indisponível'; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (compareEl) {
          var has = v.compare_at_price && v.compare_at_price > v.price;
          compareEl.textContent = has ? formatMoney(v.compare_at_price) : '';
          compareEl.hidden = !has;
        }
        var bo = !!boMap[String(v.id)];
        if (boNote) boNote.hidden = !bo;
        if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = bo ? 'Encomendar' : (v.available ? 'Adicionar à sacola' : 'Esgotado'); }
        if (waBtn) {
          var name = data.title + (data.variants.length > 1 ? ' (' + v.title + ')' : '');
          waBtn.href = waUrl(waTpl.replace('[produto]', name));
        }
        if (v.featured_image && mainImg) {
          var src = v.featured_image.src;
          mainImg.src = src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=1200';
          mainImg.removeAttribute('srcset');
          mainImg.alt = v.featured_image.alt || data.title;
        }
        if (viewerEl && viewerEl.__viewer) {
          opts.forEach(function (o) { if (o) viewerEl.__viewer.setColorByName(o); });
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
      update();

      $$('[data-qty]', wrap).forEach(function (q) {
        var input = $('input', q);
        $$('button', q).forEach(function (b) {
          b.addEventListener('click', function () {
            var n = Math.max(1, (Number(input.value) || 1) + Number(b.getAttribute('data-step')));
            input.value = n;
          });
        });
      });
    });

    // miniaturas da galeria
    $$('[data-thumbs]', root).forEach(function (wrap) {
      var main = $('[data-main-image]', wrap.closest('[data-product-section]') || document);
      if (!main) return;
      $$('button', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          main.src = b.getAttribute('data-src');
          main.removeAttribute('srcset');
          main.alt = b.getAttribute('data-alt') || '';
          $$('button', wrap).forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
        });
      });
    });
  }

  /* ---------- ordenação da coleção ---------- */
  function initSort(root) {
    $$('[data-sort]', root).forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }


  /* ---------- produtos do mesmo tamanho nas fotos ---------- */
  function autofitImages(root) {
    $$('img[data-autofit]', root).forEach(function (img) {
      if (img.__af) return;
      img.__af = true;
      var src = img.getAttribute('data-analyze-src');
      var fill = (Number(img.getAttribute('data-fill')) || 82) / 100;
      if (!src) return;
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        try {
          var W = probe.naturalWidth, H = probe.naturalHeight;
          if (!W || !H) return;
          var c = document.createElement('canvas'); c.width = W; c.height = H;
          var g = c.getContext('2d', { willReadFrequently: true });
          g.drawImage(probe, 0, 0);
          var d = g.getImageData(0, 0, W, H).data;
          // cor de fundo = média dos 4 cantos
          var corners = [0, (W - 1) * 4, (H - 1) * W * 4, ((H - 1) * W + W - 1) * 4];
          var bg = [0, 0, 0, 0];
          corners.forEach(function (i) { for (var k = 0; k < 4; k++) bg[k] += d[i + k] / 4; });
          var x0 = W, y0 = H, x1 = -1, y1 = -1;
          for (var y = 0; y < H; y++) {
            for (var x = 0; x < W; x++) {
              var i = (y * W + x) * 4, diff;
              if (bg[3] < 30) diff = d[i + 3];
              else if (d[i + 3] < 30) diff = 0;
              else diff = Math.max(Math.abs(d[i] - bg[0]), Math.abs(d[i + 1] - bg[1]), Math.abs(d[i + 2] - bg[2]));
              if (diff > 26) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
            }
          }
          if (x1 < 0) return;
          var fx0 = x0 / W, fx1 = (x1 + 1) / W, fy0 = y0 / H, fy1 = (y1 + 1) / H;
          var w = fx1 - fx0, h = fy1 - fy0, r = W / H;
          var Dh = Math.min(fill / h, fill / (w * r));
          var Dw = Dh * r;
          var left = 0.5 - ((fx0 + fx1) / 2) * Dw;
          var top = 0.5 - ((fy0 + fy1) / 2) * Dh;
          img.style.width = (Dw * 100) + '%';
          img.style.height = (Dh * 100) + '%';
          img.style.left = (left * 100) + '%';
          img.style.top = (top * 100) + '%';
          img.parentNode.classList.add('is-fit');
          // foto ampliada: pede ao navegador uma versão maior para não borrar
          var box = img.parentNode.getBoundingClientRect().width || 300;
          img.sizes = Math.ceil(box * Dw) + 'px';
        } catch (e) { /* imagem sem permissão de leitura: mantém como está */ }
      };
      probe.src = src;
    });
  }

  function initAll(root) {
    initViewers(root);
    initTabs(root);
    initHours(root);
    initExchange(root);
    initTradeIn(root);
    initProduct(root);
    initSort(root);
    autofitImages(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  // Editor de temas: reinicia a seção alterada
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
